export default {
  SET_LOGS: 'SET_LOGS',
  SET_CURRENT_LOG: 'SET_CURRENT_LOG',
  SET_LOADING: 'SET_LOADING',
};
